
//todo: AttachFileInfo není obsaženo, doplnit !!

namespace Gordic.Epk.WebControls.Vyrizeni {

    export interface IGReasonResponseEpkAsync extends IGReasonResponse {
        /** prodloužený text chyby */
        reasonlong?: string;
    }

    interface IEpkAsyncSettlementOpt {
        /** FUN pro přidělení/předání */
        ixs_fun?: string,
        /** SU pro přidělení/předání */
        ixs_su?: string,
        /** text důvodu vyřízení */
        reasonSettlementText?: string
    }

    export interface NotificationParams {
        ixp: string,
        serCislo: number,
        typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk,
        zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum 
    }

    export class AsyncNotification {

        constructor() {

        }

        /** objekt notifikace */
        private notObs: GObservableObject<IGNotificationOptions>;
        /** název skupiny */
        private group = "jres:32000779"; //RC 32000779 : Vyřízení žádosti v EPK
        /** performanceStart */
        private performanceStart: number;

        /**
         * spuštění upozornění na async. operaci
         */
        public beginOperation(ixp: string, idNotification: string) {
            var opt: IGNotificationOptions = {
                id: idNotification,
                title: "jres:32000774 " + ixp, //RC 32000774 : Vyřízení žádosti
                content: "jres:32000775", //RC 32000775 : Vyřízení žádosti bylo zahájeno
                icon: "fa-globe",
                progress: { current: 0, total: 100 },
                state: "info",
                group: this.group
            }
            this.notObs = new GObservableObject(opt);
            $.content().notification("add", this.notObs, true);
            this.performanceStart = performance.now();
        }

        /**
         * update/ukonření progressu upozornění na asynchronní operaci
         * - je nutno volat až po metodě beginOperation(opt)
         * - !! nutno zadat ID
         */
        public progressOperation(id: string, opt: IGNotificationOptions, end?: boolean | null, needsToWaitForConfirmation?: boolean) {

            opt.id = id;
            opt.group = this.group;
            // pokud zobrazujeme poslední notifikaci, změníme identifikátor, aby notifikace znovu vyskočila
            opt.id = end === true ? "idNotificationEnd" : opt.id;

            if (needsToWaitForConfirmation === true) {
                opt.content += "<br><br><i>jres:32000971</i>"; //RC 32000971 : Můžete být vyzvání k potvrzení podepsání na mobilu.
            }

            this.notObs.update(opt);
        }

        /**
         * ukončení (nutno volat na konci)
         * - !! nutno zadat ID
         */
        public endOperation(state: "success" | "error", id: string, params: NotificationParams | null, reasonResponse?: IGReasonResponseEpkAsync | null | { reason: string, type?: number, reasonlong?: string }, glog?: Wfl.WebClient.GSettlementLog) {

            var opt = this.setEndParams(state, params, reasonResponse, glog);
            this.progressOperation(id, opt);

            //info: pokud vyřízení trvá více než 5s, tak vyhodím znovu notifikační toast
            const performDiff = performance.now() - this.performanceStart;
            if (performDiff > 5000)
                $.content().notification("showToast", opt);

        }

        /**
         * zavolání samotatné operace
         */
        public runOnlyOperation(state: "success" | "error", params: NotificationParams, reasonResponse?: IGReasonResponseEpkAsync | null | { reason: string, type?: number, reasonlong?: string }, glog?: Wfl.WebClient.GSettlementLog) {
            var opt = this.setEndParams(state, params, reasonResponse, glog);
            var notObs = new GObservableObject(opt);
            $.content().notification("add", notObs, true);
        }

        private getTypPozadPod(params: NotificationParams) {

            /** zpráva notifikace */
            var txt = "";
            /** identifikátor ixp */
            var ixp = params.ixp;

            var typPozadavku = params.typPozadavku;
            var docText = "jres:32000655"; //RC 32000655 : Dokument/Spis

            // zamítnuto
            if (params.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                txt = docText + " " + ixp + " jres:32000443"; //RC 32000443 : byl úspěšně vrácen k přepracování.
            }
            // povoleno
            else {

                if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu) {
                    txt = "jres:32000645 " + ixp +  //RC 32000645 : Schválení vyřízení spisu
                        " jres:32000646";         //RC 32000646 : bylo úspěšně provedeno.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                    txt = "jres:32000636 " +        //RC 32000636 : Přidělení
                        "jres:32000656 " +        //RC 32000656 : Dokumentu/Spisu
                        ixp +
                        " jres:32000637";         //RC 32000637 : bylo úspěšně schváleno
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani) {
                    txt = "jres:32000638 " +        //RC 32000638 : Předání
                        "jres:32000656 " +        //RC 32000656 : Dokumentu/Spisu
                        ixp +
                        " jres:32000637";         //RC 32000637 : bylo úspěšně schváleno
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat) {
                    txt = docText + " " + ixp + " jres:32000442"; //RC 32000442 : byl úspěšně podepsán.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                    txt = docText + " " + ixp + " jres:32000441"; //RC 32000441 : byl úspěšně podepsán a schválen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Schvalit) {
                    txt = docText + " " + ixp + " jres:32000440"; //RC 32000440 : byl úspěšně schválen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Posoudit) {
                    txt = docText + " " + ixp + " jres:32000439"; //RC 32000439 : byl úspěšně posouzen.
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi) {
                    txt = docText + " " + ixp + " jres:32000438"; //RC 32000438 : byl úspěšně vzat na vědomí.
                }
                // Specialita pro Ukrajinu
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Splnit) {
                    //RC 32000452 : Žádost dokumentu
                    //RC 32000429 : Splnit
                    //RC 32000453 : byla úspěšně vyřízena.
                    txt = "jres:32000452 " + ixp + " 'jres:32000429' " + "jres:32000453";
                }
                else if (typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout) {
                    //RC 32000452 : Žádost dokumentu
                    //RC 32000450 : Rozhodnout
                    //RC 32000453 : byla úspěšně vyřízena.
                    txt = "jres:32000452 " + ixp + " 'jres:32000450' " + "jres:32000453";
                }
                else {
                    console.log("Neznámý typ požadavku.");
                }

            }
            return txt;
        }

        private setEndParams(state: "success" | "error", params: NotificationParams | null, reasonResponse?: IGReasonResponseEpkAsync | null | { reason: string, type?: number, reasonlong?: string }, glog?: Wfl.WebClient.GSettlementLog) {

            var title = "jres:32000133";        //RC 32000133 : Upozornění

            var requestTxt = "";
            var icon = "";
            var content = "";
            if (reasonResponse != null && reasonResponse.type! != null && reasonResponse.type === 3) {
                icon = "fa-exclamation g-state-text g-state-warning";
                content = reasonResponse.reason;
            }
            else {
                icon = state === "success" ? "fa-check-circle g-state-text g-state-success" : "fa-times g-state-text g-state-error";
                if (params == null) {
                    if (state === "success") 
                        content = "jres:32001009" //RC 32001009 : Žádost byla úspěšně vyřízena.
                    else
                        content = "jres:32001010" //RC 32001010 : Žádost při vyřízení selhala.
                }
                else {
                    if (state === "success") {
                        requestTxt = this.getTypPozadPod(params);
                    }
                    if (state === "error") {
                        requestTxt = String.Format("jres:32000739 {0}", params.ixp); //RC 32000739 : Žádost
                        requestTxt += " jres:32000741";  //RC 32000741 : při vyřízení selhala.
                    }
                    content = requestTxt;
                    if (reasonResponse != null && reasonResponse.reason != null) {
                        content += "<br><br><br>";
                        content += reasonResponse.reason;
                    }
                }

                
            }

            var defaultAction: GAction | undefined = undefined;

            if (params != null) {
                defaultAction = new GAction({
                    name: "actShowRequestDetail" + params.ixp,
                    run: (ev, ctx) => {
                        if (state === "success") {
                            Gordic.Epk.Dialogs.DetailZadostiDlg($.content(), { Ixp: params.ixp, supervisor: Gordic.Wfl.Interface.EpkSupervisorEnum.Ne, SerCislo: params.serCislo }, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                        }
                        else {
                            if (reasonResponse != null && reasonResponse.reasonlong != null) {
                                const main = $("<div>");
                                $("<div>").html(reasonResponse.reasonlong).appendTo(main);
                                $.content().dialogs.error("LOG", main);
                            }
                        }
                    }
                });
            }

            var opt: IGNotificationOptions = {
                progress: null,
                state: state,
                group: this.group,
                title: title,
                icon: icon,
                content: content,
                dateTime: new Date(),
                defaultAction: defaultAction
            }
            return opt;
        }

    }

}

// todo: validace na časové razítka šablon důvodu podpisu, dodělat obdobně jako v sync. případech thazmuka (19.8.2021)
// todo: chce to validaci na to, jestli zadost obsahuje pri podpisu nejaky soubor